import React from "react";
import { useNavigate } from "react-router-dom";

export default function AcademicCards({
  navigateTo,
  imageSrc,
  imageAlt,
  title,
}) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(navigateTo)}
      className="w-full h-[184px] laptopSm:h-[216px] rounded-2xl flex flex-col cursor-pointer"
    >
      <div className="w-full h-[74%] laptopSm:h-[70.4%] bg-slate-100 rounded-t-2xl">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover object-top rounded-t-2xl"
        />
      </div>
      <div className="w-full h-[26%] laptopSm:h-[29.6%] bg-text-dark rounded-b-2xl text-center flex items-center justify-center">
        <span className=" font-montserrat font-bold text-base laptopSm:text-2xl leading-5 tracking-[0.04em] capitalize text-white">
          {title}
        </span>
      </div>
    </div>
  );
}
